import { render, staticRenderFns } from "./PackCategory.vue?vue&type=template&id=cb166120&scoped=true"
import script from "./PackCategory.vue?vue&type=script&lang=ts"
export * from "./PackCategory.vue?vue&type=script&lang=ts"
import style0 from "./PackCategory.vue?vue&type=style&index=0&id=cb166120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb166120",
  null
  
)

export default component.exports